import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { EventCategory } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

@Injectable()
export class EventCategoryApi {
	private eventCategories = "/api/events/v2/eventCategories"

	constructor(private httpClient: HttpClient, private logger: Logger) {
	}

	public getAssignableEventCategories(): Observable<EventCategory[]> {
		return this.httpClient.get(this.eventCategories + "/search/findByAssignable?assignable=true")
				.map(response => response.json()._embedded.eventCategories)
			.catch(this.handleError);
	}

	public getEventCategory(url: string): Observable<EventCategory> {
		return this.httpClient.get(url)
				.map(response => response.json())
			.catch(this.handleError);
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/event-category-api.service.ts